export default __webpack_public_path__ + "static/media/web3-fdn-logo.00bd52fd.png";